import React, { useContext } from 'react';
import { Amplify } from 'aws-amplify';
import config from '../../aws-exports';
import { cx } from '@emotion/css';
import * as styles from './welcome.style';
import isEmpty from 'lodash/isEmpty';
import ReactGA from 'react-ga4'

import introImage from '../../assets/images/intro-img-3928.png';
import kid1 from '../../assets/images/img-9090.png';
import kid2 from '../../assets/images/img-9091.png';
import Features from './Features';
import { Link } from 'react-router-dom';
import { UserContext } from '../UserContext';
import Testimonials from './Testimonials';

Amplify.configure(config);

function Welcome() {
  const { user } = useContext(UserContext);
  return (
    <>
      <section className="container-fluid">
        <img className={cx(styles.introImg)} src={introImage} alt="" />
      </section>
      <section className={`${styles.introTextSection} container text-center`}>
        <h2 className={cx(styles.headline)}>Make learning awesome</h2>
        <p className={cx(styles.line)}>
          QuizWizard delivers engaging learning to young minds
          <br />
          Spark your child’s curiosity for learning with our new playful app
          experience.
        </p>
        {isEmpty(user) && (
          <Link to="/login" className={`${cx(styles.button)} mx-auto`}>
            sign up for free
          </Link>
        )}
      </section>
      <Features />
      {/* <Testimonials /> */}
      <section className="container">
        <div className={cx(styles.signupsection)}>
          <img className={styles.signupimg} src={kid1} alt="" />
          <div className={cx(styles.signupinner)}>
            <p className={cx(styles.signuptitle)}>
              Ready to start getting better grades?
            </p>
            {isEmpty(user) && (
              <Link to="/login" className={`${cx(styles.buttonWhite)} mx-auto`}>
                sign up for free
              </Link>
            )}
          </div>
          <img className={`${styles.signupimg} last`} src={kid2} alt="" />
        </div>
      </section>
    </>
  );
}

export default Welcome;
